@if (propertyLocationData) {
  <div>
    <div class="row" [formGroup]="propertyLocationForm">
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">المنطقة</label>
          <ng-select
            [items]="regions"
            bindLabel="name"
            bindValue="pk"
            appendTo="body"
            formControlName="address_area"
            [searchable]="true"
            [clearable]="true"
            (change)="onRegionChange($event)"
          >
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">المدينة</label>
          <ng-select
            [items]="cities"
            bindLabel="city_name"
            bindValue="pk"
            appendTo="body"
            formControlName="address_city"
            [searchable]="true"
            [clearable]="true"
            (change)="onCityChange($event)"
          >
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">الحي</label>
          <ng-select
            [items]="districts"
            bindLabel="district_name"
            bindValue="pk"
            appendTo="body"
            formControlName="district"
            [searchable]="true"
            [clearable]="true"
          >
          </ng-select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">الشارع</label>
          <input
            type="text"
            formControlName="address_street"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">رقم المبنى</label>
          <input
            type="text"
            formControlName="address_building_code"
            class="form-control disabled"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">معلم بارز</label>
          <input type="text" formControlName="landmark" class="form-control" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">كود العنوان الوطني</label>
          <input
            type="text"
            formControlName="short_address"
            class="form-control"
            maxlength="8"
            (input)="onShortAddressInput($event)"
            (blur)="onShortAddressBlur($event)"
          />
          @if (isShortAddressInvalid()) {
            <span class="error-msg">
              يجب أن يتكون من 4 أحرف إنجليزية كبيرة متبوعة بـ 4 أرقام (مثال: RRRD2929)
            </span>
          }
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label"
            >رقم الوحدة<span class="optional">(اختياري)</span></label
          >
          <input
            type="text"
            formControlName="address_unit_code"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="" class="form-label">إحداثيات الموقع</label>
          <input type="text" formControlName="location" class="form-control" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        @if (alertmsg) {
          <div class="alert-box">
            <img
              alt=""
              src="assets/images/svg/error-icon.svg"
              class="close-alert"
              (click)="hideErrorMSG()"
              alt=""
            />
            <p class="alert-msg">برجاء ادخال جميع البيانات المطلوبة</p>
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 save-btn-wrapper">
        <app-action-button
          buttonId="saveLocation"
          (submitAction)="save($event)"
        ></app-action-button>
      </div>
    </div>
  </div>
}
